import { render, staticRenderFns } from "./StoreDesigner.vue?vue&type=template&id=2cf4a232&scoped=true"
import script from "./StoreDesigner.vue?vue&type=script&lang=js"
export * from "./StoreDesigner.vue?vue&type=script&lang=js"
import style0 from "./StoreDesigner.vue?vue&type=style&index=0&id=2cf4a232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4a232",
  null
  
)

export default component.exports